import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=6ede3eee&scoped=true"
const script = {}

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=6ede3eee&scoped=true&lang=css"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ede3eee"]])

export default __exports__